import { render, staticRenderFns } from "./PersonProfileHistoryLocationInfo.vue?vue&type=template&id=49f04080&scoped=true&"
import script from "./PersonProfileHistoryLocationInfo.vue?vue&type=script&lang=js&"
export * from "./PersonProfileHistoryLocationInfo.vue?vue&type=script&lang=js&"
import style0 from "./PersonProfileHistoryLocationInfo.vue?vue&type=style&index=0&id=49f04080&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f04080",
  null
  
)

export default component.exports